module.exports = __webpack_public_path__ + "static/media/account-circle.1483576f.svg";